import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const CustomPhoneInput = ({
  label,
  value,
  onChange,
  placeholder,
  required = false,
  disabled = false,
  error,
  className = '',
  ...props
}) => {
  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <PhoneInput
        country={'fr'}
        value={value}
        onChange={onChange}
        disabled={disabled}
        enableSearch={true}
        searchPlaceholder="Search country..."
        inputClass={`!w-full !h-[40px] !text-base !border-gray-300 !rounded-md !pl-[70px] focus:!ring-1 focus:!ring-blue-500 focus:!border-blue-500 !text-black ${
          error ? '!border-red-500' : ''
        } ${disabled ? '!bg-gray-50 !text-gray-500' : ''} ${className}`}
        buttonClass={`!bg-transparent !border-gray-300 !border !rounded-l-md !border-r-0 !w-[72px] !h-[40px] ${
          disabled ? '!bg-gray-50' : ''
        }`}
        containerClass="!w-full"
        dropdownClass="!w-[300px] !rounded-md !mt-1 !border-gray-300 !shadow-lg"
        searchClass="!p-2 !m-0"
        placeholder={placeholder}
        specialLabel=""
        preferredCountries={["fr", "gb", "us", "de", "es"]}
        countryCodeEditable={false}
        {...props}
      />
      {error && (
        <p className="mt-1 text-sm text-red-500">{error}</p>
      )}
    </div>
  );
};

export default CustomPhoneInput; 